export enum ConnectorServiceEnum {
  AzureActiveDirectory = 'azure-active-directory',
  AzureOidc = 'azure-oidc',
  AzureSaml = 'azure-saml',
  BambooHR = 'bamboohr',
  Bring = 'bring',
  CatalystOne = 'catalyst-one',
  Deel = 'deel',
  Dustin = 'dustin',
  Fedex = 'fedex',
  GithubOidc = 'github-oidc',
  GoogleDevices = 'google-devices',
  GoogleOidc = 'google-oidc',
  GoogleSaml = 'google-saml',
  GoogleWorkspace = 'google-workspace',
  AlexisHR = 'alexishr',
  HaileyHR = 'haileyhr',
  Hexnode = 'hexnode',
  Hibob = 'hibob',
  HibobOauth = 'hibob-oauth',
  Ingram = 'ingram',
  Inrego = 'inrego',
  Jamf = 'jamf',
  Kandji = 'kandji',
  MicrosoftIntune = 'microsoft-intune',
  Netset = 'netset',
  Posti = 'posti',
  Postnord = 'postnord',
  ServiceNow = 'service-now',
  TdSynnex = 'td-synnex',
  Teamtailor = 'teamtailor',
  Velory = 'velory',
  Webmercs = 'webmercs',
  OktaSaml = 'okta-saml',
  OktaScim = 'okta-scim',
  Sap = 'sap',
  Elisa = 'elisa',
  TeliaLt = 'telia-lt',
  Tele2Se = 'tele2-se',
  Markit = 'markit',
  TeliaNo = 'telia-no',
  Tele2SeHardware = 'tele2-se-hardware',
  AppleBusiness = 'apple-business',
}
